export default {
  /*Authentication Apiurls*/
  signUp: "/api/v2/authentication/signup",
  login: "/api/v2/authentication/login",
  logOut: "/api/v2/authentication/logout",
  editPassword: "/api/v2/authentication/editPassword",
  requestPassword: "/api/v2/authentication/requestPassword",
  resetPassword: "/api/v2/authentication/resetPassword",
  sendOTP: "/api/v2/authentication/sendOtp",
  verifyOTP: "/api/v2/authentication/verifyOtp",
  /* WebSocket Authentication */
  SocketAuth: "/api/v2/user/authTicket",
  /*Video Apiurls*/
  // getVideo: "/api/v2/video/videos",
  getCategory: "/api/v2/video/filter/category/",
  // getCourse: "/api/v2/video/course/",
  getAllCourses: "/api/v2/video/courses",
  getCourseByCategory: "/api/v2/video/course/category/",
  getCourseByCourseId: "/api/v2/video/course/",
  getCourseReview: "/api/v2/video/course/reviews",
  getLiveCourses: "/api/v2/video/liveCourses",
  getLiveCoursesByCategory: "/api/v2/video/liveCourses/category/",
  getLiveByCourseId: "/api/v2/video/liveCourse/",
  filterAllCourses: "/api/v2/video/filter/courses/",
  filterCoursesByCategory: "/api/v2/video/filter/coursesByCategory/",
  filterLiveCoursesByCategory: "/api/v2/video/filter/liveCoursesByCategory/",
  filterLiveCourses: "/api/v2/video/filter/liveCourse/",
  searchKeys: "/api/v2/video/filter/search/",
  searchCourses: "/api/v2/video/filter/courseSearch/",

  /*customer Apiurls*/
  getCustomerDetails: "/api/v2/user/userDetails",
  editCustomerDetails: "/api/v2/user/editDetails",
  courseReview: "/api/v2/user/courseReview",
  teacherReview: "/api/v2/user/teacherReview",
  followTeacher: "/api/v2/user/followTeacher",
  unfollowTeacher: "/api/v2/user/unfollowTeacher",
  getFollowingTeachers: "/api/v2/user/student/followingTeachers",
  editTeacherReview: "/api/v2/user/teacher/review",
  editCourseReview: "/api/v2/user/review",
  addToWishlist: "/api/v2/user/addWishList",
  removeFromWishlist: "/api/v2/user/removeWishList",
  getWishlist: "/api/v2/user/wishList",
  searchTeacher: "/api/v2/user/teacher/search/",
  requestACourse: "/api/v2/user/requestCourse",
  contactUs: "/api/v2/user/contactUs",
  getSubscribedCourses: "/api/v2/user/subscribedCourses/",
  getTeacherCourses: "/api/v2/user/teacher/courses",

  /* Teacher ApiUrls*/
  teacherSignUp: "/api/v2/user/teacher/signup",
  uploadResume: "/api/v2/user/resumeUpload",
  getAllTeachers: "/api/v2/user/teacher/teachers",
  getTeachersByCategory: "/api/v2/user/teacher/category/",
  getTeacherDetails: "/api/v2/user/teacher/teacherDetails/",
  getTeacherReview: "/api/v2/user/teacher/teacherReview",
  getCourseSubscribedStudents: "/api/v2/user/teacher/courseSubscribedStudents",
  getFollowingStudents: "/api/v2/user/teacher/followingStudents",

  /* Subscription ApiUrls*/
  getPaymentMethods: "/api/v2/video/paymentMethods",
  orderCreation: "/api/v2/video/order",
  paymentValidation: "/api/v2/video/paymentValidation",

  /* Cart Apiurls*/

  insertCart: "/api/v2/user/insertCart",
  getCartDetails: "/api/v2/user/cart"
};
